export enum CompletionMode {
  ONBOARDING = 'onboarding',
  PAYMENT = 'payment',
}

export type CompletionRedirectState = {
  mode: CompletionMode
  returnTo?: string
  returnState?: unknown
  cancelState?: unknown
}
